import { DataRequest } from 'shared/data/datarequest';
import { ActivityReturnValue } from 'runtime/data/activityreturnvalue';

export class ActivityUpdate extends DataRequest {
    static $type = 'Web.ActivityUpdate';

    results: ActivityReturnValue[];
}
